import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const felang = document.documentElement.lang;

document.querySelectorAll('.auto-clipboard').forEach(el => {
  const icon = document.createElement('i');
  icon.className = 'mdi mdi-content-copy clipboard-icon';
  icon.style.cursor = 'pointer';
  icon.style.marginRight = '0.5em';
  icon.title = felang == 'it' ? 'Copia numero' : 'Nummer kopieren';

  icon.addEventListener('click', () => {
    const text = el.innerText || el.textContent;
    icon.classList.add('clicked');
    navigator.clipboard.writeText(text).catch(err => {
      console.error('Kopieren fehlgeschlagen:', err);
    });
  });

  el.insertAdjacentElement('beforebegin', icon);
});

document.querySelectorAll('.mdi-arrow-right.primary').forEach(el => {
  const wrapper = document.createElement('div');
  wrapper.classList.add('animated-button'); // Add class to wrapper if needed

  const innerWrapper = document.createElement('div');
  innerWrapper.classList.add('inner'); // Add class to inner wrapper if needed

  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(innerWrapper);
  innerWrapper.appendChild(el);
});

gsap.registerPlugin(ScrollTrigger);

const icons = document.querySelectorAll('.icon-mdi');
icons.forEach(icon => {
  icon.textContent = ''; // Clear the text content of each element
});


  function shuffleOrder(container = '.random-order', col = '.col-3') {

      var $row = $(container); // Select the row
      var $cols = $row.children(col); // Select all columns inside the row
      
      // Count the number of columns
      var numCols = $cols.length;
      
      // Loop through each column and assign a random order class
      $cols.each(function() {

        console.log("shuffle col")
          // Generate a random number between 1 and numCols
          var randomOrder = Math.floor(Math.random() * numCols) + 1;
          
          $(this).css('order', randomOrder); 
      });
  }

  // Call the function to shuffle the order classes
  shuffleOrder();
  shuffleOrder('.swiper-wrapper', '.swiper-slide');
  shuffleOrder('.random-order', '.col-xl-3');


const swipers = document.querySelectorAll('.swiper-container');

swipers.forEach(function(swiper) {

  const cols = swiper.dataset.cols || 4; 
  const uid = swiper.dataset.uid || 'generic'; 
  const config = swiper.dataset.config || false;
  
  if(config) {
    config = config.split("-")
    console.log(config);
  } else {
    config = [
      cols,
      Math.min(cols, 2),
      Math.min(cols, 2),
      Math.min(cols, 2),
      1
    ]
  }

  const slides = swiper.querySelectorAll('.swiper-slide');

  var swiper = new Swiper(swiper, {
    slidesPerView: cols,
    spaceBetween: 40,
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    navigation: {
      nextEl: ".swiper-button-next-"+uid,
      prevEl: ".swiper-button-prev-"+uid,
    },
    pagination: {
      el: ".swiper-pagination-"+uid,
      clickable: true
    },
    breakpoints: {
      300: {
        slidesPerView:config[4] ?? 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-"+uid,
          prevEl: ".swiper-button-prev-"+uid,
        },
      },
      800: {
        slidesPerView:config[3],
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-"+uid,
          prevEl: ".swiper-button-prev-"+uid,
        },
      },
      1000: {
        slidesPerView:config[2],
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next-"+uid,
          prevEl: ".swiper-button-prev-"+uid,
        },
      },
      1300: {
        slidesPerView: config[1],
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next-"+uid,
          prevEl: ".swiper-button-prev-"+uid,
        },
      },
      1400: {
        slidesPerView: config[0],
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next-"+uid,
          prevEl: ".swiper-button-prev-"+uid,
        },
      },
    },
  
  });
});
/*
--bs-breakpoint-sm: 600px;
--bs-breakpoint-md: 800px;
--bs-breakpoint-lg: 1000px;
--bs-breakpoint-xl: 1300px;
--bs-breakpoint-xxl: 1700px;
*/
const tabContents = document.querySelectorAll('.tab-content');

// Iterate over each element and log its 'id' attribute
tabContents.forEach(function(tabContent) {
    gsap.to("#"+tabContent.id, {
        scrollTrigger: {
          trigger: "#"+tabContent.id,
          start: "top top+=125px",      
          end: "bottom top",     
          pin: true,              
          markers: false, 
          onUpdate: function(self) {
            // Set opacity to 0 as the user scrolls
            const opacity = 1 - self.progress;  // Decrease opacity from 1 to 0 as the scroll progresses
            gsap.to("#"+tabContent.id, { opacity: opacity });
          },
        },
        duration: 2,
    });
});

tabContents = document.querySelectorAll('.frame-type-carousel_small');

tabContents.forEach(function(tabContent) {
    gsap.to("#"+tabContent.id, {
        scrollTrigger: {
            trigger: "#"+tabContent.id,
            start: "top top+=125px",      
            end: "bottom top",     
            pin: true,              
            markers: false, 
            onUpdate: function(self) {
              // Set opacity to 0 as the user scrolls
              const opacity = 1 - self.progress;  // Decrease opacity from 1 to 0 as the scroll progresses
              gsap.to("#"+tabContent.id, { opacity: opacity });
            },
          },
        duration: 2,
    });

});

tabContents = document.querySelectorAll('.gallery-itemmm');

// Iterate over each element and log its 'id' attribute
tabContents.forEach(function(tabContent) {

    gsap.to(tabContent, {
        scrollTrigger: {
            trigger: tabContent,
            start: "top top+=100px",      
            end: "bottom top",            
            markers: false, 
        },
        x: () => randomValue(-500, 500),    // Random horizontal position between -500px and 500px
        y: () => randomValue(-500, 500),    // Random vertical position between -500px and 500px
        ease: "power2.out",                 // Ease function for a smooth effect
        markers: false, 
      });

});

gsap.utils.toArray('.card').forEach(img => {
  gsap.to(img, {
    scrollTrigger: {
      trigger: img,
      start: "top-=200px bottom", // Start animation when 80% of the viewport height
      toggleActions: "play none none none", // Play only once
      markers: false, 
    },
    x: 0, // Reset the horizontal position
    y: 0, // Reset the vertical position
    opacity: 1, // Make the image fully visible
    duration: 1, // Animation duration
    ease: "power2.out"
  });
});

gsap.utils.toArray('h2').forEach(img => {
  gsap.to(img, {
    scrollTrigger: {
      trigger: img,
      start: "top-=200px bottom", 
      toggleActions: "play none none none", // Play only once
      markers: false, 
    },
    x: 0, // Reset the horizontal position
    y: 0, // Reset the vertical position
    opacity: 1, // Make the image fully visible
    duration: 1, // Animation duration
    ease: "power2.out"
  });
});

gsap.utils.toArray('h1, h3').forEach(img => {
  gsap.to(img, {
    scrollTrigger: {
      trigger: img,
      start: "top bottom", 
      toggleActions: "play none none none", // Play only once
      markers: false, 
    },
    x: 0, // Reset the horizontal position
    y: 0, // Reset the vertical position
    opacity: 1, // Make the image fully visible
    duration: 3, // Animation duration
    ease: "power2.out"
  });
});


function randomValue(min, max) {
    return Math.random() * (max - min) + min;
  }

window.gsap = gsap;

let scrollInterval = null;
const scrollSpeed = 5; // Geschwindigkeit des Scrollens (Pixel pro Schritt)

document.addEventListener("keydown", (event) => {
    if (event.key === "a" && !scrollInterval) {
        scrollInterval = setInterval(() => {
            window.scrollBy(0, scrollSpeed);

            // Wenn das Ende der Seite erreicht ist, stoppen
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                clearInterval(scrollInterval);
                scrollInterval = null;
            }
        }, 10); // 10ms Intervall für smooth scrolling
    }
});

document.addEventListener("keyup", (event) => {
    if (event.key === "a" && scrollInterval) {
        clearInterval(scrollInterval);
        scrollInterval = null;
    }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.link-arrow').forEach(element => {
      element.classList.remove('link-arrow');
      element.classList.add('mdi', 'text-mdi', 'mdi-arrow-right');
  });
});

const toggleSwitch = document.getElementById('toggleSwitch');
const body = document.body;

/*
if(localStorage) var theme = localStorage.getItem('centrorevisionibz.it_theme');
if(theme == 'day') {
    body.classList.add('day-theme'); 
}
// Add event listener to toggle class on body when switch is clicked
toggleSwitch.addEventListener('change', function() {
  if (this.checked) {
    body.classList.add('day-theme'); // Add dark mode class
    if(localStorage) localStorage.setItem('centrorevisionibz.it_theme', 'day')
  } else {
    body.classList.remove('day-theme'); // Remove dark mode class
    if(localStorage) localStorage.setItem('centrorevisionibz.it_theme', 'night')
  }
});
*/

/*!
 * centrorevisioni.bz.it v1.0.0
 * Copyright 2017-2024 Alex C.
 */

// remove empty frames
const frameInners = document.querySelectorAll('.frame-inner');

frameInners.forEach(frameInner => {
  const hasVisibleChildren = Array.from(frameInner.children).some(child => {
    const style = window.getComputedStyle(child);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  });

  if (!hasVisibleChildren) {
    // frameInner.closest('.frame').remove();
  } 
});

document.getElementById('c8')?.classList.add('d-none');
document.getElementById('c9')?.classList.add('d-none');
document.getElementById('c65')?.classList.add('d-none');

var submitButton = document.querySelector('.contact-fixed button[type="submit"]');
if(submitButton) {
  submitButton.classList.remove(...submitButton.classList);
  submitButton.classList.add('link-arrow');
}

function isFormSubmit() {
  const url = window.location.href;
  const urlObj = new URL(url);
  const params = urlObj.searchParams;

  return params.get('tx_form_formframework[action]') === 'perform';
}

if (isFormSubmit()) {
  document.querySelectorAll('.contact-fixed').forEach(function(hiddenElement) {
    console.log(hiddenElement);
      hiddenElement.classList.remove('d-none');
      document.getElementById('c9').classList.remove('d-none');
  });
} 

document.querySelectorAll('.open-modal').forEach(function(element) {
  element.addEventListener('click', function() {
    const target = element.dataset.target; 
    document.querySelectorAll('.contact-fixed').forEach(function(hiddenElement) {
        hiddenElement.classList.remove('d-none');

        document.getElementById('c8').classList.add('d-none');
        document.getElementById('c9').classList.add('d-none');
        document.getElementById('c65').classList.add('d-none');

        document.getElementById(target).classList.remove('d-none');

    });
  });
});

document.querySelectorAll('.link-close.contact-form').forEach(function(element) {
  element.addEventListener('click', function() {
    document.querySelectorAll('.contact-fixed').forEach(function(hiddenElement) {
        hiddenElement.classList.add('d-none');
    });
  });
});

document.querySelectorAll('.carousel').forEach(function(carouselElement) {
  var carousel = new bootstrap.Carousel(carouselElement);

  function handleSwipe(e) {
      const x = Math.abs(e.deltaX);
      const y = Math.abs(e.deltaY);

      if (x > y) {
          // Swipe detected
          if (e.deltaX > 0) {
              carousel.prev(); // Swipe right, go to previous slide
          } else {
              carousel.next(); // Swipe left, go to next slide
          }
      }
  }

  carouselElement.addEventListener('touchstart', function(e) {
      e.startX = e.touches[0].clientX;
      e.startY = e.touches[0].clientY;
  });

  carouselElement.addEventListener('touchmove', function(e) {
      e.deltaX = e.touches[0].clientX - e.startX;
      e.deltaY = e.touches[0].clientY - e.startY;
      handleSwipe(e);
  });
});


document.querySelectorAll('.mobile-link').forEach(trigger => {
  trigger.addEventListener('click', () => {
    // Alle .mobile-text-Elemente ausblenden
    document.querySelectorAll('.mobile-text').forEach(text => {
      text.style.display = 'none';
    });
    
    // Das nächste .mobile-text-Element nach dem angeklickten .trigger anzeigen
    let nextText = trigger.nextElementSibling;
    while (nextText && !nextText.classList.contains('mobile-text')) {
      nextText = nextText.nextElementSibling;
    }
    if (nextText) {
      nextText.style.display = 'block';
    }
  });
});


